const pageContainerMargin = {
	init: function () {
		// get DOM nodes
		const body = document.body;
		const videoContainer = document.querySelector('.video-container');
		const pageContainer = document.querySelector('.page-container');
		const headerContent = document.querySelector('.video-container .content .wrapper');

		// get height of content wrapper including padding
		// https://stackoverflow.com/a/23749355
		function getAbsoluteHeight(el) {
			let styles = window.getComputedStyle(el);
			let padding = parseFloat(styles['paddingTop']) + parseFloat(styles['paddingBottom']);

			// min-height 400
			return Math.ceil(el.offsetHeight + padding) > 400
				? Math.ceil(el.offsetHeight + padding)
				: 400;
		}

		// set height and margin of the video and page containers based on content height
		function setHeights() {
			let headerContentHeight = getAbsoluteHeight(headerContent);

			videoContainer.style.height = headerContentHeight + 'px';

			// adjust for admin bar
			if (body.classList.contains('logged-in')) {
				pageContainer.style.marginTop = headerContentHeight - 32 + 'px';
			} else {
				pageContainer.style.marginTop = headerContentHeight + 'px';
			}
		}

		// call heights on resize and init
		window.addEventListener('resize', () => {
			setHeights();
		});
		setHeights();
	}
};

export default pageContainerMargin;
